<template>
	<div
		class="lq-remarks-wrap"
		:class="{
			'lq-remarks-wrap--empty': !displayText,
			'lq-remarks-wrap--short': displayText && isShort
		}">
		<template v-if="displayText">
			<el-tooltip
				:disabled="!overflow"
				:content="displayText"
				placement="top-start"
				:open-delay="2000"
				popper-class="lq-remarks-tooltip">
				<div ref="textEl" class="lq-remarks-text">{{ displayText }}</div>
			</el-tooltip>
		</template>
		<div v-else class="lq-remarks-text lq-remarks-text--empty">{{ emptyText }}</div>
	</div>
</template>

<script>
	export default {
		name: 'LqRemarksCell',
		props: {
			text: {
				type: String,
				default: ''
			},
			emptyText: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				overflow: false,
				isShort: false
			}
		},
		computed: {
			displayText() {
				return this.text != null ? String(this.text).trim() : ''
			}
		},
		watch: {
			displayText() {
				this.scheduleMeasure()
			}
		},
		mounted() {
			this.scheduleMeasure()
			this.bindResizeObserver()
		},
		updated() {
			this.scheduleMeasure()
			this.bindResizeObserver()
		},
		beforeDestroy() {
			if (this._resizeObserver) {
				this._resizeObserver.disconnect()
				this._resizeObserver = null
			}
			if (this._measureTimer) {
				clearTimeout(this._measureTimer)
				this._measureTimer = null
			}
		},
		methods: {
			bindResizeObserver() {
				if (typeof ResizeObserver === 'undefined') return
				this.$nextTick(() => {
					if (!this._resizeObserver) {
						this._resizeObserver = new ResizeObserver(() => {
							this.scheduleMeasure()
						})
					}
					this._resizeObserver.disconnect()
					if (this.$refs.textEl) {
						this._resizeObserver.observe(this.$refs.textEl)
					}
				})
			},
			scheduleMeasure() {
				this.$nextTick(() => {
					if (this._measureTimer) clearTimeout(this._measureTimer)
					this._measureTimer = setTimeout(() => {
						this._measureTimer = null
						this.measure()
					}, 0)
				})
			},
			measure() {
				const el = this.$refs.textEl
				if (!el || !this.displayText) {
					this.overflow = false
					this.isShort = false
					return
				}

				const style = window.getComputedStyle(el)
				const lineHeight = parseFloat(style.lineHeight) || 16
				const maxLines = 3
				const maxHeight = lineHeight * maxLines
				const width = el.clientWidth || el.offsetWidth
				if (!width) return

				const probe = document.createElement('div')
				probe.textContent = this.displayText
				probe.style.cssText = [
					'position:fixed',
					'visibility:hidden',
					'pointer-events:none',
					'left:-9999px',
					'top:0',
					`width:${width}px`,
					`font-size:${style.fontSize}`,
					`line-height:${style.lineHeight}`,
					'word-break:break-word',
					'white-space:normal'
				].join(';')
				document.body.appendChild(probe)
				const fullHeight = probe.offsetHeight
				document.body.removeChild(probe)

				const lines = Math.max(1, Math.ceil(fullHeight / lineHeight - 0.01))
				this.overflow = fullHeight > maxHeight + 1
				this.isShort = lines <= 2
			}
		}
	}
</script>
